export default {
      id: "icon-img-usage",
      viewBox: "0 0 16 17",
      url: "/" + "assets/sprite.svg#icon-img",
      toString: function () {
        return this.url;
      }
    }